// extracted by mini-css-extract-plugin
export var container = "_96-0";
export var icon = "_96-1";
export var text = "_96-2";